<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Devoluciones a clientes</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <!-- <button
                class="btn btn-primary btn-sm"
                @click="showModalAdddevolucionNew"
                type="button"
              >
                Nueva Devolución
                <i class="fa fa-plus"></i>
              </button> -->
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-6">
              <div action="#" class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" @click="filterData">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActiva"
                  @click="filterData"
                >
                  <option value="">Todos</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="9">Anulado</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Fecha</th>
                <th scope="col">Tienda</th>
                <th scope="col"># de Caja</th>
                <th scope="col"># de Serie</th>
                <th scope="col"># Total Cargo</th>
                <th scope="col"># Total Devuelto</th>
                <th scope="col">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td scope="row">{{ current.numero }}</td>
                <td scope="row">{{ current.fecha }}</td>
                <td>{{ current.tienda.nombre }}</td>
                <td>{{ current.caja.caja }}</td>
                <td>{{ current.caja.serie_nota }}</td>
                <td>{{ current.valor_total_cargo }}</td>
                <td>{{ current.valor_total_devuelto }}</td>
                <td>{{ current.estado_str }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>

    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAdddevolucionNew"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h4 class="onboarding-title text-center">
                  Nueva Devolución basada en un Cargo
                </h4>
              </div>
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <CargoComponentView />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import CargoComponentView from "@/components/commons/CargoComponentView";
import { mapGetters } from "vuex";

export default {
  components: {
    PaginationComponent,
    CargoComponentView,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActiva: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      caja: "cargos/caja",
    }),
  },
  mounted() {
    let self = this;
    self.refreshData();
  },
  methods: {
    showModalAdddevolucionNew(detalle) {
      let self = this;
      $("#modalAdddevolucionNew").modal();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActiva = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        estado: this.filterActiva,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      DevolucionesService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-devoluciones-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-devoluciones-editar",
          params: { id: current.id },
        });
      }
    },
    showModalEdit() {},
  },
};
</script>
